import { useMutation } from '@tanstack/react-query';
import { atualizaConfigRelatorioApi } from '../api/AtualizaConfigRelatorioApi';
import type { AtualizaConfigRelatorioPayload } from '../types';

export function useAtualizaConfigRelatorio() {
  return useMutation<void, Error, AtualizaConfigRelatorioPayload>({
    mutationFn: atualizaConfigRelatorioApi,
  });
}
